AOS.init();

$('.humburg').on('click', function () {
  $('.heder_open').addClass('open');
  $('.humburger').addClass('open');
  $('body').addClass('margin');
});

$( '.close' ).on("click", function(){
  $('.heder_open').removeClass('open');
  $('.humburger').removeClass('open');
  $('body').removeClass('margin');
});

$(document).ready(function() {
    if (localStorage.getItem('advertOnce') !== 'true') {
          $('#age-verify').show();
    }else{
      $('#age-verify').hide();
    }
    $('.yes').click(function(e) {
        $('#age-verify').fadeOut(); 
        localStorage.setItem('advertOnce','true');
    });
    $('.no').click(function(e) {
        window.location = "https://www.google.com";
    });
});

$('.blog__posts').slick({
  arrows:false,
  infinite: false,
  dots:true,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 749,
      settings: {
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });